export default "__VITE_ASSET__w_iCd32P__"